import { render, staticRenderFns } from "./declarelist.vue?vue&type=template&id=25a3da20&scoped=true"
import script from "./declarelist.vue?vue&type=script&lang=js"
export * from "./declarelist.vue?vue&type=script&lang=js"
import style0 from "./declarelist.vue?vue&type=style&index=0&id=25a3da20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3da20",
  null
  
)

export default component.exports